import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError, getControl, getGroup } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { isEqual } from 'lodash-es';
import { applyAuxError } from './helpers/conclusioni-form.helper';
import { formPaths } from '@shared/constants/form-paths.const';

/*
 * Le altre regole cross-section di questo file (my_TipoSezEnte, my_CkNuovoSocioCatSpec,
 * my_CkObbligoBilSoc, i controlli sui libri sociali, ckRistorni) sono coperte da
 * conclusioni-ck-proposte.rules.ts (chiave my_CkProposte), verificate contro l'XSF InfoPath
 * legacy incluso il guard "CkProposte === '1'" mancante qui. my_TipoSezEnteII resta perché non
 * ha un equivalente in quel file — vedi memoria conclusioni-attestato-duplicate-rules-bug.
 */
export const conclusioniAttestatoCrossSectionRules: FormGroupRules = {
    my_TipoSezEnteII: (form: FormGroup) => {
        const datiIdentificativiGroup = getGroup(form, formPaths.datiIdentificativi);
        const schedaCoopSocialiGroup = getGroup(form, formPaths.schedaCoopSociali);
        const effettivitaBaseSocialeGroup = getGroup(form, formPaths.baseSociale);
        const my_TipoSezEnteControl = getControl(datiIdentificativiGroup, 'my_TipoSezEnte');
        const my_CkAmmessiSociFinanz: string = getControl(schedaCoopSocialiGroup, 'my_CkAmmessiSociFinanz').value;
        const my_SociGiuCoopData: string = getControl(effettivitaBaseSocialeGroup, 'my_SociGiuCoopData').value;
        const my_CkTrattasiDiConsorzio: string = getControl(schedaCoopSocialiGroup, 'my_CkTrattasiDiConsorzio').value;
        const errors = my_TipoSezEnteControl.errors ? my_TipoSezEnteControl.errors : {};

        addRemoveError(
            !(toNum(my_TipoSezEnteControl.value) !== 2 || toNum(my_CkAmmessiSociFinanz) !== 0 || toNum(my_SociGiuCoopData) <= 0 || toNum(my_CkTrattasiDiConsorzio) === 1),
            errors,
            'my_TipoSezEnteII',
            {
                status: "Cooperative sociali: è possibile ammettere, ai sensi dell'art.11 della L.381/1991, persone giuridiche pubbliche o private, a condizione che nel loro statuto sia previsto il finanziamento o lo sviluppo delle attività di tali cooperative",
            }
        );

        my_TipoSezEnteControl.setErrors(isEqual(errors, {}) ? null : errors);
        applyAuxError(form, 'tipoSezEnteII', errors, 'my_TipoSezEnteII');
    },
};
